// Shared Planes mark geometry (32×32 viewBox).
// Used by PlanesMark.jsx and scripts/generate-favicon.mjs.

export const PLANES_VIEWBOX = 32;
export const PLANES_PLANE = 17.5;
export const PLANES_RADIUS = 4;
export const PLANES_A = { x: 3.75, y: 3.75 };
export const PLANES_B = { x: 9.75, y: 9.75 };
export const PLANES_OPACITY = 0.55;

/** Brand fill: blue (sky) / green (grass) / yellow (sun) hard seams. */
export const PLANES_COLORS = {
  a: '#2684fc',
  b: '#00ac47',
  overlap: '#ffba00',
};

// defaultTheme foreground — static mono PNG exports (see generate-favicon.mjs).
export const PLANES_FOREGROUND_DARK_MODE = '#E8EAED';
export const PLANES_FOREGROUND_LIGHT_MODE = '#202124';
